import { ICity } from 'entities/City/City.models';

export const sortCityListByDetectedCity = (cityList: ICity[], detectedCity: ICity | null): ICity[] => {
  if (!detectedCity) {
    return cityList;
  }

  return [detectedCity, ...cityList.filter((i) => i.id !== detectedCity.id)];
};
